// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1_KSr","header":"MergedInvoice_header__1ASD7"};